module.exports = __webpack_public_path__ + "img/img1.df0c9b2d.svg";